import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from "react-scroll";
import { LanguageContext } from '../context/LanguageContext';

function WebHeader() {
  const { t, language, setLanguage } = useContext(LanguageContext);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img className="logo1" src="https://storage.googleapis.com/tt202501/images/techtalamo_logo2.jpg" alt="Logo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">

          {/* Links principales */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <ScrollLink className="nav-link web-nav-link" to="como-funciona" smooth={true} duration={500}>{t('headHowItWorks')}</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link web-nav-link" to="diagnostico" smooth={true} duration={500}>{t('headDiagnosis')}</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link web-nav-link" to="compania" smooth={true} duration={500}>{t('headCompany')}</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link web-nav-link" to="otros-productos" smooth={true} duration={500}>{t('headOtherProducts')}</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link web-nav-link" to="contacto" smooth={true} duration={500}>{t('headContact')}</ScrollLink>
            </li>
            <li className="nav-item">
              <Link className="nav-link web-nav-link" to="/0.login">{t('headLogin')}</Link>
            </li>
          </ul>

          {/* Selector de idioma — derecha, letras azules */}
          <ul className="navbar-nav ms-auto">
            <li className="nav-item d-flex align-items-center" style={{ gap: 2 }}>
              <button
                className="btn btn-link px-1 py-0"
                onClick={() => setLanguage('en')}
                style={{
                  fontWeight: language === 'en' ? 700 : 400,
                  opacity: language === 'en' ? 1 : 0.5,
                  textDecoration: 'none',
                  color: '#0a66c2',
                  fontSize: 13,
                }}
              >EN</button>
              <span style={{ color: '#0a66c2', opacity: 0.4, fontSize: 13 }}>|</span>
              <button
                className="btn btn-link px-1 py-0"
                onClick={() => setLanguage('es')}
                style={{
                  fontWeight: language === 'es' ? 700 : 400,
                  opacity: language === 'es' ? 1 : 0.5,
                  textDecoration: 'none',
                  color: '#0a66c2',
                  fontSize: 13,
                }}
              >ES</button>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
}

export default WebHeader;
